export default "/react/logoUnatarget-36c238a7.png";